<div>
    <a *ngIf="!isGlobalUser" href="javascript:void(0)" (click)="onLinkClick()">
        {{params.value}}
    </a>
    <span *ngIf="isGlobalUser">{{params.value}}</span>
    <i *ngIf="isGroupAdmin  && !isGlobalUser" class="fas fa-user-friends custom-table__icon fill"></i>
    <i *ngIf="isGroupAdmin  && isGlobalUser" class="fas fa-user"></i>
    <i *ngIf="isNonAssociatedUser && !isGlobalUser" class="fas fa-user-slash custom-table__icon fill"></i>
</div>